// Mise en page de la zone de jeu : le labyrinthe (carré) prend la plus grande taille possible
// dans la hauteur que lui laissent les autres blocs (nom et devise, scoreboard, rangée de boutons),
// sans dépasser la largeur de la zone de jeu. Les blocs sont ensuite centrés verticalement par le
// flex de #gameArea.

export function createLayout({ area, blocks, maze, onChange }) {
  function fit() {
    const style = getComputedStyle(area);
    const gap = parseFloat(style.rowGap) || 0;
    const padding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
    const blocksH = blocks.reduce((sum, block) => sum + block.offsetHeight, 0);
    const availableH = area.clientHeight - padding - blocksH - blocks.length * gap;
    const size = Math.max(120, Math.floor(Math.min(area.clientWidth, availableH)));
    const px = `${size}px`;
    if (maze.style.width !== px) {
      maze.style.width = px;
      onChange?.();
    }
  }

  const observer = new ResizeObserver(fit);
  observer.observe(area);
  blocks.forEach((block) => observer.observe(block));
  fit();

  return { fit, destroy: () => observer.disconnect() };
}
